// extracted by mini-css-extract-plugin
export default {"container":"Markdown_container__LnyXq","markdown":"Markdown_markdown__HK10i"};